// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "calendar_source_event".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "calendar_source_event" table (1:1 with a DB row, on the wire). */
export const calendarSourceEventAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    calendarSourceId: z.string(),
    externalEventId: z.string(),
    sourceUpdatedAt: z.string().datetime(),
});
//# sourceMappingURL=calendarSourceEvent.js.map